import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { LessonVideo } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class LessonVideosService extends BaseApiService<
	LessonVideo,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}

	validate(url: string): Promise<void> {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			xhr.open("GET", url);
			xhr.addEventListener("load", () => {
				if (xhr.status === 200) {
					resolve();
				} else {
					reject(xhr.response);
				}
			});
			xhr.addEventListener("error", err => reject(err));
			xhr.send();
		});
	}
}

export const lessonVideosService = new LessonVideosService(URLS.LESSON_VIDEOS);
